// app/javascript/trix_alignment.js
class BaseAlignmentElement extends HTMLElement {
  constructor(alignment) {
    super();
    this._alignment = alignment;
  }

  connectedCallback() {
    this.style.display = "block";
    this.style.width = "100%";
    this.style.textAlign = this._alignment;
  }
}

class AlignLeftElement extends BaseAlignmentElement {
  constructor() {
    super("left");
  }
}

class AlignCenterElement extends BaseAlignmentElement {
  constructor() {
    super("center");
  }
}

class AlignRightElement extends BaseAlignmentElement {
  constructor() {
    super("right");
  }
}

// Register the custom elements
window.customElements.define("align-left", AlignLeftElement);
window.customElements.define("align-center", AlignCenterElement);
window.customElements.define("align-right", AlignRightElement);

export { AlignLeftElement, AlignCenterElement, AlignRightElement };
